import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ServiceloaderService } from '../components/loader/serviceloader/serviceloader.service';
import { ToastrService } from '../components/toastr/toastr.service';
import { UtilityFunctions } from '../utilities/utility-func';
import { StorageService } from '../services/storage.service';
import { Config } from '../config/config';
import { environment } from '../../environments/environment';
import 'rxjs/Rx';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';

@Injectable({
  providedIn: 'root',
})
export class HttpLayerService {
  private monitoring = {
    pendingRequestsNumber: 0,
  };

  public counter = 0;
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private _http: HttpClient,
    private _router: Router,
    public _commonLoader: ServiceloaderService,
    public _toastLoad: ToastrService,
    private _utility: UtilityFunctions,
    private session: StorageService,
  ) { }

  private showLoader(): void {
    this._commonLoader.show();
  }
  private hideLoader(): void {
    if (this.monitoring.pendingRequestsNumber === 0) {
      this._commonLoader.hide();
    }
  }

  get(url: string, options?: any): Observable<any> {
    try {
      // this.showLoader();
      this.monitoring.pendingRequestsNumber++;
      return this.handleResponse(this._http.get(url)).finally(() => {
        this.monitoring.pendingRequestsNumber--;
        // this.hideLoader();
      });
    } catch (error) {
      console.error(error);
    }
  }

  post(url: string, data: any, values?: any, hideLoader?: any): Observable<any> {
    try {
      if (!hideLoader) {
        this.showLoader();
        // tslint:disable-next-line: no-increment-decrement
        this.monitoring.pendingRequestsNumber++;
      }
      let defaults = {};
      if (url.indexOf('/login') === -1) {
        defaults = {
          user_id: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID),
          user_name: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_NAME),
          user_type: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE),
          user_role: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE),
          userId: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID),
        };
      }
      const payload = Object.assign(defaults, data);
      return this.handleResponse(this._http.post(url, payload, values).timeout(300000)).finally(() => {
        if (!hideLoader) {
          // tslint:disable-next-line: no-increment-decrement
          this.monitoring.pendingRequestsNumber--;
          this.hideLoader();
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  postEncrypted(url: string, data: any, values?: any): Observable<any> {
    try {
      this.showLoader();
      const defaults = {
        user_id: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID),
        user_name: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_NAME),
        user_type: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE),
        user_role: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE),
        userId: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID),
      };
      const payload = Object.assign(defaults, data);
      const session_id = this._utility.getSessionKey(true);
      if (!session_id) {
        this.session.api.local.clear();
        this._router.navigate(['p/login']);
      }
      const encryptedPayload = this._utility.encrypt(payload);

      const headers = {
        'Content-Type': 'text/plain',
      };
      const headersConfig = new HttpHeaders(headers);
      const requestOptions: any = { headersConfig, responseType: 'text' };
      this.monitoring.pendingRequestsNumber++;
      return this.handleResponse(
        this._http.post(url, encryptedPayload, requestOptions).map((res: any) => {
          let response = res;
          response = this._utility.decrypt(response);
          if (response) {
            response = JSON.parse(response);
          } else {
            response = { status: 'failed', message: 'failed' };
          }
          return response;
        }),
      ).finally(() => {
        this.monitoring.pendingRequestsNumber--;
        this.hideLoader();
      });
    } catch (error) {
      console.error(error);
    }
  }

  postFormData(url: string, data: any, values?: any): Observable<any> {
    try {
      this.showLoader();
      const headerOptions = {
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      };

      const httpHeaders = new HttpHeaders();
      httpHeaders.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      httpHeaders.set('user_id', this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID));
      const options = { headers: httpHeaders };

      return this.handleResponse(this._http.post(url, data, headerOptions).timeout(300000)).finally(() => {
        this.hideLoader();
      });
    } catch (error) {
      console.error(error);
    }
  }

  postDashboard(url: string, data: any, values?: any): Observable<any> {
    try {
      // if (this.counter <= 4) {
      //   this.counter++;
      return this.handleResponseDashboard(this._http.post(url, data, values).timeout(300000)).finally(() => {
      });
      // } else {
      //   setInterval(() => {
      //     if (this.counter > 0) {
      //       this.postDashboard(url, data, values);
      //     }
      //   }, 5000)
      // }
    } catch (error) {
      console.error(error);
    }
  }

  handleResponse(observable: Observable<any>, isBackgroundServiceCall: boolean = false): Observable<any> {
    return observable.catch((err, source) => {
      // this._toastLoad.toast('info', 'Connecting...', 'Awaiting Network connection', true);
      if (err.status === 401 && !err.url.endsWith('/login')) {
        this.session.api.local.clear();
        this._toastLoad.toast('warning', 'Session Expired', 'Please login again.', true);
        setTimeout(() => {
          this._router.navigate(['p/login']);
          return Observable.empty();
        }, 2000);
      }
      return Observable.throw(err);

    }).finally(() => {
      if (this.monitoring.pendingRequestsNumber === 0) {
        this.hideLoader();
      }
    });
  }

  handleResponseDashboard(observable: Observable<any>, isBackgroundServiceCall: boolean = false): Observable<any> {
    return observable.catch((err, source) => {
      this._toastLoad.toast('error', 'Error', 'Error while fetching data', true);
      if (err.status === 401 && !err.url.endsWith('/login')) {
        this._router.navigate(['p/login']);
        return Observable.empty();
      }
      return Observable.throw(err);

    }).finally(() => {
      this.counter--;
      // if (this.monitoring.pendingRequestsNumber === 0) {
      // }
    });
  }
  loginEncrypted(url: string, data: any, values?: any): Observable<any> {
    try {
      this.showLoader();
      const defaults = {
        user_id: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ID),
        user_name: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_NAME),
        user_type: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_TYPE),
        user_role: this.session.api.local.get(Config.CONSTANTS.STORAGE.USER_ROLE),
        userId: this.session.api.local.get(Config.CONSTANTS.STORAGE.USERID),
      };
      const payload = data; // Object.assign(defaults, data);
      // const session_id = this._utility.getSessionKey(true);
      // if (!session_id) {
      //   this.session.api.local.clear();
      //   this._router.navigate(['p/login']);
      // }
      const encryptedPayload = this._utility.encryptLogin(payload);

      const headers = {
        'Content-Type': 'text/plain',
      };
      const headersConfig = new HttpHeaders(headers);
      const requestOptions: any = { headersConfig, responseType: 'text' };
      this.monitoring.pendingRequestsNumber++;
      return this.handleResponse(
        this._http.post(url, encryptedPayload, requestOptions).map((res: any) => {
          let response = res;
          response = this._utility.decryptLogin(response);
          if (response) {
            response = JSON.parse(response);
          } else {
            response = { status: 'failed', message: 'failed' };
          }
          return response;
        }),
      ).finally(() => {
        this.monitoring.pendingRequestsNumber--;
        this.hideLoader();
      });
    } catch (error) {
      console.error(error);
    }
  }

  public handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    // this._toastLoad.toast('error', 'Error', 'Error while fetching data', true);
    // console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
